<form class="w-100 h-100 form" [formGroup]="Form">
  <h4 class="text-center mt-2 mb-4">
    {{data['data']['id'] ? 'Editar' : 'Agregar'}} {{data['modal'] === 'profile' ? 'perfil' : 'rol'}}
  </h4>
  <ng-container [ngSwitch]="data.modal">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Nombre de {{data['modal'] === 'profile' ? 'perfil' : 'rol'}}</mat-label>
      <input matInput [placeholder]="data['modal'] === 'profile' ? 'Nombre de perfil' : 'Nombre de rol'" formControlName="name" maxlength="100">
      <mat-error *ngIf="false">Este campo es <b>Requerido</b></mat-error>
    </mat-form-field>
    <ng-template [ngSwitchCase]="'role'">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Descripción</mat-label>
        <textarea matInput placeholder="Descripción de role" formControlName="description" maxlength="200">
        </textarea>
        <mat-error *ngIf="false">Este campo es <b>Requerido</b></mat-error>
      </mat-form-field>
    </ng-template>
  </ng-container>
  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="Form.invalid" (click)="send()">
      Guardar
    </button>
  </div>
</form>
